import React, { FC, useCallback } from 'react';
import { AppBar } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { PortalConfigSelector } from 'store/config/selectors';
import { UserDataSelector } from 'store/user/selector';
import { logOutUser } from 'store/auth';

import Action from 'components/Action';
import Notifications from './Notifications';
import TechnicianData from './TechnicianData';
import TechnicianVerification from './TechnicianVerification';
import UISwitch from 'components/Layout/components/UISwitch';

import { ReactComponent as LeaveIcon } from 'assets/leave.icon.svg';
import { UI_CONSTANTS } from 'constants/ui';
import { PROFILE } from 'router/routes';

import useStyles from '../styles';
import { tt } from '@i18n/tt';

const AppBarComponent: FC = () => {
  const { contactName } = useAppSelector(UserDataSelector);
  const { caption, logo } = useAppSelector(PortalConfigSelector);

  const dispatch = useAppDispatch();
  const classes = useStyles();
  const navigate = useNavigate();

  const handleLogOut = useCallback(() => {
    dispatch(logOutUser({}));
  }, [dispatch]);

  return (
    <AppBar
      component="header"
      className={classes.appBar}
      style={{ height: `${UI_CONSTANTS.APP_BAR_HEIGHT}px` }}
    >
      <div className={classes.logoContainer}>
        {logo && <img src={logo} alt="logo" />}
        {caption}
      </div>
      <div className={classes.contactName}>
        <UISwitch />
        <TechnicianVerification />
        <TechnicianData />
        <Notifications />
        <div
          onClick={() => {
            navigate(PROFILE);
          }}
          className={classes.name}
        >
          {contactName}
        </div>
        <Action tooltip={tt('common.logout')} onClick={handleLogOut} icon={<LeaveIcon />} />
      </div>
    </AppBar>
  );
};

export default AppBarComponent;
